/**
 * Страница 404: подпись в поле поиска.
 *
 * Перенесено из инлайна [`404.php:239`] (Этап 6 §0, группа 9).
 *
 * ⚠️ Поле приходит из `searchform.php` родительской темы
 * с `placeholder="Поиск…"`, здесь он заменяется на «Введите запрос..».
 * Правка через JS, а не шаблон, потому что форма общая для всего
 * сайта, а текст нужен только на 404.
 *
 * ⚠️ `.search-field` есть и на других страницах (в шапке), поэтому
 * модуль ограничен якорём 404 — иначе подпись поменялась бы всюду.
 * В инлайне ограничителем служило само место вставки.
 *
 * ⚠️ Якорь — `body.error404` от WordPress, а не класс из шаблона.
 * `.page-content.error-404` в `404.php` есть, но ограничивать по нему
 * нельзя: поле поиска лежит ВНЕ этого контейнера, и выборка
 * `.error-404 .search-field` дала бы ноль. Проверено по отданному HTML.
 */

/** Класс body, который WordPress ставит на странице 404. */
const ANCHOR = 'body.error404';

/** Текст из инлайна сохранён буквально, включая две точки на конце. */
const PLACEHOLDER = 'Введите запрос..';

export default function NotFound() {
    if (!document.querySelector(ANCHOR)) {
        return;
    }

    // Полей на странице может быть два (шапка + контент) — инлайн брал
    // первое через querySelector, поведение сохранено
    const field = document.querySelector('.search-field');

    if (field) {
        field.setAttribute('placeholder', PLACEHOLDER);
    }
}
